import { useState } from "react";

/**
 * useCollapsible — persistent collapsible card state
 * ──────────────────────────────────────────────────
 * Wraps a boolean "collapsed" flag in `localStorage` so a card stays
 * open/closed between page navigations. Silent when localStorage is
 * unavailable (private-mode Safari, SSR, etc.).
 *
 *   const [collapsed, toggle] = useCollapsible("ni.market.collapsed");
 */
export default function useCollapsible(storageKey, defaultCollapsed = false) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const v = localStorage.getItem(storageKey);
      if (v === "1") return true;
      if (v === "0") return false;
      return defaultCollapsed;
    } catch { return defaultCollapsed; }
  });
  const toggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try { localStorage.setItem(storageKey, next ? "1" : "0"); }
      catch { /* localStorage unavailable — no-op */ }
      return next;
    });
  };
  return [collapsed, toggle];
}
